<div class="col-md-12 clear-all margin-bottom-30">
  <div class="current-medication">
    <span role="heading" aria-level="3">{{tabSquareQuesObj.questionLabel}}</span>
  </div>
  @if (tabSquareQuesObj.questionText) {
    <div class="mt-15">
      @if (tabSquareQuesObj.questionText) {
        <div class="newPos" role="dropdown">
          <label [id]="'lbl-'+pageName+'-'+controlName" [attr.for]="pageName+'-'+controlName">{{tabSquareQuesObj.questionText}}</label>
        </div>
      }
      @if (tabSquareQuesObj.helpText) {
        <div class="info-icon d-view">
          <app-tool-tip-notification
            [childId]="'dropdownStandard'"
            [tooltipData]="initializeToolTipDateComp(tabSquareQuesObj)">
          </app-tool-tip-notification>
        </div>
      }
    </div>
  }
  @if (tabSquareQuesObj.helpText) {
    <div class="info-icon mt-view">
      <app-tool-tip-notification
        [childId]="'dropdownStandard'"
        [tooltipData]="initializeToolTipDateComp(tabSquareQuesObj)"
        (displayMobileTooltipEmitter)="displayTooltipMessage()">
      </app-tool-tip-notification>
    </div>
  }
  @if (parent.get(controlName).touched && mandatoryErrorMsg) {
    <div class="reduce-width question-style normal-ques-style newPos form-validation-error">
      <i class="icon icon-error" aria-hidden="true"></i>
      <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">{{mandatoryErrorMsg}}</p>
    </div>
  }
  <div class="col-md-12 clear-all margin-top-30">
    <div class="col-md-12 clear-all">
      <div class="col-md-10 pad-0">
        @for (tab of tabList; track tab; let i = $index) {
          <div class="col-md-4 clear-all">
            <div>
              <button id="{{domId+ '-' + i  + '-switchBtnForTabSquare'}}" type="button" name="switchBtnForTabSquare" (click)="switchTab(tab)" data-toggle="button" [ngClass]="{'enabledBtn':tab.selected, 'disabledBtn':!tab.selected, 'invalid-tab':tab.invalidTab}"
                class="btn btn-secondary btn-sm margin-0">
                <span class="fl-left textPos">{{tab.name}} - {{tab.id + 1}}</span>
                @if (tabList.length>1) {
                  <img id="{{domId+ '-delete'}}" (click)="deleteTab(tab)" [src]="tab.selected===true?'./assets/images/icon-closed-circle-white.svg':'./assets/images/icon-closed-circle-blue.svg'"
                    class="icon-finder fl-right" />
                }
              </button>
            </div>
          </div>
        }
      </div>
      <div class="col-md-2">
        <div class="col-md-12">
          <div class="row rowPos" [ngClass]="{'disableClick':disableAddBtn}">
            <span class="fl-left">
              <a class="Add" name="addBtnForTabSquare" role="button" tabindex="0"
                id="{{domId+ '-addBtnForTabSquare'}}" [class.disabled]="disableAddBtn"  (keyup.enter)="addTab()" (click)="addTab()">
                <span>Add</span>
                <span class="visually-hidden">Add reading</span>
              </a>
            </span>
            <!--  <span class="fl-right">
            <i class="icon icon-chevron-right mr-18" (click)="scrollALert()"></i>
          </span> -->
        </div>
      </div>
    </div>
  </div>
</div>
@if (parent.get(controlName).touched
  &&
  parent.get(controlName).errors) {
  <div class="reduce-width question-style normal-ques-style newPos form-validation-error">
    <i class="icon icon-error" aria-hidden="true"></i>
    <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">{{errorMsg}}</p>
  </div>
}
@if (displayTooltipAlert) {
  <app-modal [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
  (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
}
</div>